import React, { useState } from 'react';
import { 
    Box, Stack, Typography, IconButton, Menu, MenuItem, useMediaQuery, Drawer, List, ListItem, ListItemText, Avatar
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LoginIcon from '@mui/icons-material/Login';
import LanguageIcon from '@mui/icons-material/Language';
import { NavLink, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import logo from '../assets/logoverctical.png';
import { useTheme } from '@mui/material/styles';

function Navbar() {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const user = JSON.parse(localStorage.getItem("user"));
    const isLoggedIn = user && user.token;

    const [anchorEl, setAnchorEl] = useState(null);
    const [drawerOpen, setDrawerOpen] = useState(false);

    const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);
    
    const handleLogout = () => {
        localStorage.removeItem("user");
        navigate("/login");
        window.location.reload();
    };

    return (
        <Stack
            direction="row"
            sx={{
                backgroundColor: "#15513c",
                paddingBottom: 2,
                paddingTop: 2,
                alignItems: "center",
                justifyContent: "space-between",
                color: "#fff",
                width: "100%"
            }}
        >
            <Stack direction="row" spacing={2} alignItems="center" sx={{ flex: 1, justifyContent: "center" }}>
                <Link to="/" style={{ display: "flex", alignItems: "center", textDecoration: "none", color: "#fff" }}>
                    <Box display="flex" alignItems="center" sx={{ cursor: "pointer" }}>
                        <Typography sx={{ fontSize: "16px", fontWeight: "bold" }}>اللغة</Typography>
                        <IconButton sx={{ color: "#fff" }}>
                            <LanguageIcon />
                        </IconButton>
                    </Box>
                </Link>

                {!isMobile && isLoggedIn && (
                    <>
                        <IconButton onClick={handleMenuOpen}>
                            <Avatar src={user.userphoto} alt={user.username} />
                        </IconButton>
                        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                            <MenuItem onClick={() => navigate("/profile")}>الملف الشخصي</MenuItem>
                            <MenuItem onClick={handleLogout}>تسجيل الخروج</MenuItem>
                        </Menu>
                    </>
                )}

                {!isLoggedIn && (
                    <Link to="/login" style={{ display: "flex", alignItems: "center", textDecoration: "none", color: "#fff" }}>
                        <Typography sx={{ fontSize: "16px", fontWeight: "bold" }}>تسجيل الدخول</Typography>
                        <LoginIcon sx={{ ml: 1 }} />
                    </Link>
                )}
            </Stack>

            { ( <Link to="/" style={{ flex: 1, display: "flex", justifyContent: "center" }}>
                <img src={logo} alt="Logo" style={{ width: "95.54px", height: "42px", objectFit: "contain" }} />
            </Link>)}

            {isMobile ? (
                <IconButton sx={{ color: "#fff" }} onClick={() => setDrawerOpen(true)}>
                    <MenuIcon />
                </IconButton>
            ) : (
                <Stack direction="row" spacing={3} alignItems="center" sx={{ flex: 1, justifyContent: "center" }}>
                    <NavLink to="/" className="link" style={navLinkStyle}>الرئيسية</NavLink>
                    <NavLink to="/donations" className="link" style={navLinkStyle}>حالات التبرع</NavLink>
                </Stack>
            )}

            <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
                <Box sx={{ width: 250, backgroundColor: "#15513c", height: "100%", color: "#fff", p: 2 }}>
                    <List>
                        <ListItem button component={Link} to="/" onClick={() => setDrawerOpen(false)}>
                            <ListItemText primary="الرئيسية" sx={{ color: "#fff" }} />
                        </ListItem>
                        <ListItem button component={Link} to="/donations" onClick={() => setDrawerOpen(false)}>
                            <ListItemText primary="حالات التبرع" sx={{ color: "#fff" }} />
                        </ListItem>
                        {isLoggedIn && (
                            <>
                                <ListItem button component={Link} to="/profile" onClick={() => setDrawerOpen(false)}>
                                    <ListItemText primary="الملف الشخصي" sx={{ color: "#fff" }} />
                                </ListItem>
                                <ListItem button onClick={handleLogout}>
                                    <ListItemText primary="تسجيل الخروج" sx={{ color: "#fff" }} />
                                </ListItem>
                            </>
                        )}
                    </List>
                </Box>
            </Drawer>
        </Stack>
    );
}

const navLinkStyle = {
    textDecoration: "none",
    color: "#fff",
    fontWeight: "bold",
    transition: "0.3s",
    fontSize: "16px"
};

export default Navbar;
